import React from 'react';

function Features() {
  return (
    <section className="section">
      <h2>Características Principales</h2>
      <ul>
        <li>✅ Fácil de usar</li>
        <li>✅ Alta seguridad</li>
        <li>✅ Diseño intuitivo</li>
      </ul>
    </section>
  );
}

export default Features;
